export default {
  BuPlanExpenseBudget: 150, // 'Dự toán chi đầu năm theo MLNS',
  BuPlanExpenseBudgetAdd: 151, // 'Dự toán chi bổ sung theo MLNS',
  BuPlanExpenseBudgetSupplement: 320, // 'Dự toán chi điều chỉnh theo MLNS',
  BuPlanExpenseActivity343: 325, // 'Dự toán chi đầu năm theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanExpenseActivityAdd343: 326, // 'Dự toán chi bổ sung theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanExpenseActivitySupplement343: 327, // 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanExpenseActivity344: 328, // 'Dự toán chi đầu năm theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanExpenseActivityAdd344: 329, // 'Dự toán chi bổ sung theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanExpenseActivitySupplement344: 330, // 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanExpenseActivity342: 322, // 'Dự toán chi đầu năm theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  BuPlanExpenseActivityAdd342: 323, // 'Dự toán chi bổ sung theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  BuPlanExpenseActivitySupplement342: 324, // 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  BuPlanExpenseActivityVt: 340, // 'Dự toán chi đầu năm theo NDKT (Vũ Thư)',
  BuPlanExpenseActivityAddVt: 341, // 'Dự toán chi bổ sung theo NDKT (Vũ Thư)',
  BuPlanExpenseActivitySupplementVt: 342, // 'Dự toán chi điều chỉnh theo NDKT (Vũ Thư)',
};
